import { memo } from 'react';
import Slider from '@dtvgo/slider';
import { useSeekableStart } from './ProgressBarContext.js';
import { ProgressBarClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function SeekableStartFill(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$flat = _ref.flat,
    flat = _ref$flat === void 0 ? false : _ref$flat;
  return /*#__PURE__*/jsx(Slider.FillTemplate, {
    className: ProgressBarClassNames.element('seekable-start-fill', className),
    lowerValue: 0,
    value: useSeekableStart(),
    flat: flat
  });
}
var SeekableStartFill$1 = /*#__PURE__*/memo(SeekableStartFill);

export { SeekableStartFill$1 as default };
//# sourceMappingURL=SeekableStartFill.js.map
